import { Box, CircularProgress } from '@mui/material';
import { colors, spacing, radius } from 'common/theme';
import { TextHot } from 'components/common/TextHot';
import { ButtonHot, BUTTON_MODE } from 'components/common/ButtonHot';
import GiftMissIcon from 'assets/personal_zone/Gift_Miss.svg';
import { IconHot } from 'components/common/IconHot';
import { generateTestId } from 'app/functions';
import { useTranslations } from 'common/hooks/useTranslations';
export const ConfirmContent = ({ onConfirm, onKeep, testID, isMobile, loading = false }) => {
  const { translate } = useTranslations();
  return (
    <Box
      dir="rtl"
      testId={generateTestId(testID, 'content')}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        width: '100%',
      }}
    >
      <Box
        testId={generateTestId(testID, 'icon')}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: `${spacing.lg}px`,
        }}
      >
        <IconHot
          src={GiftMissIcon}
          size={112}
        />
      </Box>
  
      <TextHot
        testID={generateTestId(testID, 'title')}
        size="xxxl"
        bold="bold"
        isLtr={true}
        color="primary"
        sx={{ marginBottom: `${spacing.md}px` }}
      >
        {translate('cancel_confirm_modal_title')}
      </TextHot>
  
      <TextHot
        testID={generateTestId(testID, 'description')}
        size="l"
        isLtr={true}  
        color="subtle"
        sx={{ marginBottom: `${spacing.xl}px`, maxWidth: 280 }}
      >
        {translate('cancel_confirm_modal_description')}
      </TextHot>
  
      <Box
        testId={generateTestId(testID, 'button-group')}
        sx={{
          display: 'flex',
          flexDirection: isMobile ? 'column' : 'row',
          gap: `${spacing.sm}px`,
          width: '100%',
          marginBottom: `${spacing.lg}px`,
        }}
      >
        <ButtonHot
          testID={generateTestId(testID, 'keep-btn')}
          mode={BUTTON_MODE.PRIMARY}
          onClick={onKeep}
          disabled={loading}
          sx={{
            flex: isMobile ? 'none' : 1,
            width: isMobile ? '100%' : 'auto',
            borderRadius: `${radius.xl}px`,
            padding: `${spacing.md}px`,
          }}
        >
          {translate('cancel_confirm_modal_keep_button')}
        </ButtonHot>
        <ButtonHot
          testID={generateTestId(testID, 'confirm-btn')}
          mode={BUTTON_MODE.OUTLINED}
          onClick={onConfirm}
          disabled={loading}  
          sx={{
            flex: isMobile ? 'none' : 1,
            width: isMobile ? '100%' : 'auto',
            borderRadius: `${radius.xl}px`,
            padding: `${spacing.md}px`,
            border: `1px solid ${colors.system.border.default}`,
            color: colors.system.text.primary,
          }}
        >
          {loading ? <CircularProgress size={20} color="inherit" /> : translate('cancel_confirm_modal_cancel_button')}
        </ButtonHot>
      </Box>
  
      {/* Footer Text */}
      <TextHot
        testID={generateTestId(testID, 'footer')}
        size="s"
        color="subtle"
        isLtr={true}
        sx={{ textAlign: 'left', lineHeight: 1.5, paddingBottom: '12px' }}
      >
        {translate('modal_disclaimer_text')}
      </TextHot>
    </Box>
  );
};